const fraudTypeInfractionAPI = require('../infraction/fraudType');

const fraudType = {
  applicationFraud: 0,
  muleAccount: 1,
  scammerAccount: 2,
  other: 3,
  unknown: 4,
  convertToJDPI(type) {
    switch (type) {
      case fraudTypeInfractionAPI.APPLICATION_FRAUD:
        return this.applicationFraud;
      case fraudTypeInfractionAPI.MULE_ACCOUNT:
        return this.muleAccount;
      case fraudTypeInfractionAPI.SCAMMER_ACCOUNT:
        return this.scammerAccount;
      case fraudTypeInfractionAPI.OTHER:
        return this.other;
      case fraudTypeInfractionAPI.UNKNOWN:
        return this.unknown;
      default:
        throw new Error('Invalid fraud type to convert to JDPI');
    }
  }
};

module.exports = fraudType;
